module.exports = __webpack_public_path__ + "static/create_calendar_choose_template-88070f5dc28e79254133594b2eac02b2.png";